import { Chip, TextField, Typography, alpha, Box, styled } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useMemo, useState } from 'react';

import { extractSkills } from 'lib/utils';

const StyledLabel = styled(Typography)({
	marginBottom: 0,
	borderColor: '#8B8B8B'
});

const StyledInputRoot = styled(Box)({
	backgroundColor: 'white',
	padding: '0 !important'
});

const StyledInputBase = styled(TextField)({
	padding: 0,
	width: '100%',
	'& input': {
		'-webkit-appearance': 'none',
		'-moz-appearance': 'none',
		height: 22.5,
		appearance: 'none',
		padding: '12px 8px',
		borderRadius: 4,
		backgroundColor: '#fff',
		transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
		fontSize: 15,
		'&:focus': {
			boxShadow: `${alpha('#999999', 0.25)} 0 0 0 0.2rem`,
			borderColor: '#90caf9'
		}
	}
});

const MultiAutosuggest = ({
	className,
	value,
	options,
	label,
	name,
	placeholder = 'Select',
	handleChange,
	handleInputChange,
	...props
}) => {
	const [defaultValue, setDefaultValue] = useState();
	const showPlaceHolder = useMemo(() => value.length === 0, [value]);

	const handleOnChange = (_, newValue) => {
		handleChange({
			target: {
				name: name,
				value: newValue.map((v) => v.value)
			}
		});
	};

	const setInitialValues = () => {
		let initialValues = [];

		// skills categories from feedback drills are shaped differently
		const extractedSkills = extractSkills(value);

		initialValues = options.filter(
			(o) =>
				value.includes(o.value) ||
				extractedSkills.includes(o.label.toLowerCase())
		);
		setDefaultValue(initialValues);
	};

	useEffect(() => {
		if (value) {
			setInitialValues();
		}
	}, [value, options]);

	return (
		<div>
			<StyledLabel variant="body2" color="textSecondary">
				{label}
			</StyledLabel>
			{defaultValue && (
				<Autocomplete
					multiple
					componentsProps={{
						inputRoot: { component: StyledInputRoot }
					}}
					value={defaultValue}
					onChange={handleOnChange}
					options={options}
					getOptionLabel={(option) => option.label}
					renderTags={(tagValue, getTagProps) =>
						tagValue.map((option, index) => (
							<Chip label={option.label} {...getTagProps({ index })} />
						))
					}
					renderInput={(params) => {
						return (
							<StyledInputBase
								{...params}
								variant="outlined"
								placeholder={showPlaceHolder ? placeholder : ''}
							/>
						);
					}}
				/>
			)}
		</div>
	);
};

export default MultiAutosuggest;
